module.exports = __webpack_public_path__ + "img/13.0a4ae3f7.jpg";